// Script para limpiar categories y crear SOLO las categorías correctas
export {};

(window as any).fixCategories = async function() {
  console.log('🧹 Limpiando categories y creando SOLO las categorías correctas...');
  
  try {
    // Verificar que Firebase esté disponible
    if (!(window as any).auth) {
      throw new Error('Firebase no está disponible');
    }
    
    const { db, collection, doc, setDoc, deleteDoc, getDocs, serverTimestamp } = (window as any).auth;
    
    // Obtener el ID del usuario actual
    const userId = (window as any).auth.auth.currentUser?.uid;
    if (!userId) {
      throw new Error('Usuario no autenticado');
    }

    console.log(`👤 Usuario: ${userId}`);

    // PASO 1: Eliminar todos los documentos existentes en categories
    console.log('🧹 Eliminando documentos existentes en categories...');
    const categoriesRef = collection(db, 'users', userId, 'categories');
    const snapshot = await getDocs(categoriesRef);
    
    const deletePromises: Promise<void>[] = [];
    snapshot.forEach((doc: any) => {
      console.log(`🗑️ Eliminando: ${doc.id}`);
      deletePromises.push(deleteDoc(doc.ref));
    });
    
    await Promise.all(deletePromises);
    console.log(`✅ ${deletePromises.length} documentos eliminados`);

    // PASO 2: Crear SOLO las categorías correctas con nombres exactos
    console.log('📂 Creando SOLO las categorías correctas...');
    
    const exactCategories = {
      'REMERA': {
        name: 'REMERA',
        fields: {
          talle: {
            type: 'select',
            options: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', 'Único'],
            multiple: true,
            required: true
          },
          tipo: {
            type: 'select',
            options: ['Manga corta', 'Manga larga', 'Musculosa', 'Crop Top', 'Polo', 'Térmica'],
            required: true
          },
          cuello: {
            type: 'select',
            options: ['Redondo', 'En V', 'Polo', 'Escote Bote', 'Cuello alto'],
            required: true
          },
          estilo: {
            type: 'select',
            options: ['Casual', 'Urbano', 'Deportivo', 'Básico', 'Oversize'],
            multiple: true,
            required: true
          }
        },
        enabled: true
      },
      
      'CAMPERA': {
        name: 'CAMPERA',
        fields: {
          talle: {
            type: 'select',
            options: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', 'Único'],
            multiple: true,
            required: true
          },
          tipo: {
            type: 'select',
            options: ['Abrigo grueso', 'Deportiva', 'Rompeviento', 'Jean', 'Cuero', 'Inflable', 'Bomber', 'Parka', 'Impermeable'],
            required: true
          },
          material: {
            type: 'select',
            options: ['Algodón', 'Poliéster', 'Cuero', 'Eco-Cuero', 'Denim', 'Nylon', 'Lana', 'Softshell', 'Gabardina'],
            required: true
          },
          tipoCierre: {
            type: 'select',
            options: ['Cierre', 'Abotonado'],
            required: true
          },
          estilo: {
            type: 'select',
            options: ['Casual', 'Urbano', 'Deportivo', 'Formal', 'Outdoor'],
            multiple: true,
            required: true
          }
        },
        enabled: true
      },
      
      'PANTALÓN': {
        name: 'PANTALÓN',
        fields: {
          talle: {
            type: 'select',
            options: ['26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'Único'],
            multiple: true,
            required: true
          },
          tipo: {
            type: 'select',
            options: ['Jean', 'Jogger', 'Babucha', 'Sastrero', 'Deportivo', 'Cargo', 'Chupín', 'Oxford', 'Recto', 'Acampanado'],
            required: true
          },
          corte: {
            type: 'select',
            options: ['Regular Fit', 'Slim Fit', 'Wide Leg', 'Recto', 'Chupín', 'Flare'],
            required: true
          },
          tiro: {
            type: 'select',
            options: ['Alto', 'Medio', 'Bajo'],
            required: true
          },
          largo: {
            type: 'select',
            options: ['Largo', 'Corto', 'Short', 'Bermuda', '7/8', '3/4'],
            required: true
          },
          material: {
            type: 'select',
            options: ['Denim', 'Algodón', 'Gabardina', 'Poliéster', 'Lino', 'Frisa', 'Elastano'],
            required: true
          },
          estilo: {
            type: 'select',
            options: ['Casual', 'Formal', 'Urbano', 'Deportivo'],
            multiple: true,
            required: true
          }
        },
        enabled: true
      }
    };

    // Campos globales
    const globalFields = {
      sku: {
        type: 'text',
        generated: true,
        required: true
      },
      stock: {
        type: 'number',
        format: 'thousands',
        required: true
      },
      precioCompra: {
        type: 'currency',
        symbol: '$',
        format: 'thousands',
        required: true
      },
      precioVenta: {
        type: 'currency',
        symbol: '$',
        format: 'thousands',
        required: true
      },
      fechaIngreso: {
        type: 'date',
        format: 'DD/MM/AA',
        required: true
      },
      marca: {
        type: 'select',
        searchable: true,
        required: true
      },
      proveedor: {
        type: 'select',
        searchable: true,
        required: true
      },
      genero: {
        type: 'select',
        options: ['Hombre', 'Mujer', 'Niños', 'Niñas', 'Unisex'],
        multiple: true,
        required: true
      },
      temporada: {
        type: 'select',
        options: ['Verano', 'Otoño', 'Invierno', 'Primavera', 'Atemporal'],
        required: true
      }
    };

    // Crear cada categoría con nombre exacto como ID
    for (const [categoryName, categoryData] of Object.entries(exactCategories)) {
      console.log(`📂 Creando: ${categoryName}`);
      
      const completeCategoryData = {
        ...categoryData,
        fields: {
          ...categoryData.fields,
          ...globalFields
        },
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp()
      };
      
      // Usar el nombre exacto como ID del documento
      const categoryRef = doc(db, 'users', userId, 'categories', categoryName);
      await setDoc(categoryRef, completeCategoryData);
      
      console.log(`✅ "${categoryName}" creada con ID: ${categoryName}`);
    }
    
    console.log('🎉 Categorías corregidas exitosamente');
    console.log('📋 Categorías creadas con nombres exactos:');
    Object.keys(exactCategories).forEach(name => {
      console.log(`   - ${name} (ID: ${name})`);
    });
    
    return {
      success: true,
      message: 'Categorías corregidas con nombres exactos',
      categories: Object.keys(exactCategories)
    };
    
  } catch (error) {
    console.error('❌ Error:', error);
    return {
      success: false,
      error: error instanceof Error ? error.message : error
    };
  }
};

console.log('🔧 Script de corrección de categorías cargado');
console.log('💡 Usa: window.fixCategories()');
